module.exports = __webpack_public_path__ + "img/bell.bdf67b83.png";